import {
  GET_COUNTRIES_LOADING,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { getCountriesUrl } from "api/apiUrls";

export const getCountriesAction = () => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: GET_COUNTRIES_LOADING, payload: true });
    const response = await listItemsService(`${getCountriesUrl}`);

    dispatch({ type: GET_COUNTRIES_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: GET_COUNTRIES_FAILURE, payload: err });
  } finally {
    dispatch({ type: GET_COUNTRIES_LOADING, payload: false });
  }
};
